import CampoMoeda from '../../componentes/CampoMoeda'
import type { Produto } from '../../db/tipos'
import { embalagemDoProduto, rotuloDoPreco, temEmbalagemFechada } from '../../produtos/embalagem'
import { textoPreco } from '../../precos/rascunhoDaTabela'

// Uma linha do desenho dela (28/09): caixa, codigo + nome, Preco | Comissao,
// e o avulso numa 2a linha so em produto de caixa. Sem setinha (decisao dela).
export default function LinhaDaTabela({ produto, valores, anterior, marcada, podeMarcar, alterada, erro, incompleta = false, aoCorrigir, aoMarcar, aoMudar }: {
  produto: Produto
  valores: { preco: string; avulso: string; comissao: string }
  anterior: number | null
  marcada: boolean; podeMarcar: boolean; alterada: boolean; erro?: string
  // Sem as informacoes basicas (decisao dela 01/10): vermelho claro, para conferir.
  incompleta?: boolean
  // "Corrigir" (pedido dela 01/10): abre o produto direto em Editar.
  aoCorrigir?: (e: { preventDefault: () => void }) => void
  aoMarcar: () => void
  aoMudar: (campo: 'preco' | 'avulso' | 'comissao', texto: string) => void
}) {
  const caixa = temEmbalagemFechada(produto)
  const borda = erro ? 'border-red-400 bg-red-50' : marcada ? 'border-sky-300 bg-sky-50' : alterada ? 'border-teal-600 bg-white'
    : incompleta ? 'border-red-200 bg-red-50' : 'border-slate-200 bg-white'
  const campo = 'w-full border border-slate-300 rounded-lg px-2 py-1.5 text-sm text-right'
  return (
    <li data-testid={`linha-${produto.id}`} data-incompleta={incompleta || undefined} className={`rounded-xl border shadow-sm p-2.5 flex gap-2 ${borda}`}>
      {podeMarcar && (
        <input type="checkbox" checked={marcada} onChange={aoMarcar} aria-label={`Marcar ${produto.codigo}`} className="mt-1 h-5 w-5 shrink-0" />
      )}
      <div className="min-w-0 flex-1 space-y-1.5">
        <p className="text-sm leading-tight">
          <span className="font-semibold text-sky-700 mr-2">{produto.codigo}</span>
          <span className="font-medium text-slate-800 break-words">{produto.descricao}</span>
        </p>
        <div className="grid grid-cols-2 gap-2">
          <label className="block text-[11px] text-slate-500">{rotuloDoPreco(produto)}
            <CampoMoeda aria-label={`Preço de ${produto.codigo}`} placeholder="sem preço" value={valores.preco}
              onChange={(t) => aoMudar('preco', t)} className={campo} />
          </label>
          <label className="block text-[11px] text-slate-500">Comissão (%)
            <input aria-label={`Comissão de ${produto.codigo}`} inputMode="decimal" value={valores.comissao}
              onChange={(ev) => aoMudar('comissao', ev.target.value)} className={campo} />
          </label>
        </div>
        {anterior !== null && (
          <p className="text-[11px] text-slate-500">Preço anterior: R$ {textoPreco(anterior)}</p>
        )}
        {caixa && (
          <label className="block text-[11px] text-slate-500">Avulso ({embalagemDoProduto(produto).nome})
            <CampoMoeda aria-label={`Preço avulso de ${produto.codigo}`} placeholder="não vende" value={valores.avulso}
              onChange={(t) => aoMudar('avulso', t)} className={`${campo} w-1/2 block`} />
          </label>
        )}
        {erro && <p className="text-xs text-red-700">{erro}</p>}
        {incompleta && aoCorrigir && (
          <button type="button" onClick={aoCorrigir} aria-label={`Corrigir ${produto.codigo}`}
            className="rounded-lg border border-red-300 bg-white text-red-700 px-3 py-1 text-xs font-medium">Corrigir</button>
        )}
      </div>
    </li>
  )
}
